// InvoiceModal.jsx
import React from "react";
import { Modal, Button } from "react-bootstrap";
import InvoicePage from "./InvoicePage";


function InvoiceModalPage({ show, handleClose, handleCreate }) {
  return (
    <Modal show={show} onHide={handleClose} size="lg" centered>
      <Modal.Header closeButton className="modal-header-custom" style={{ backgroundColor: "#007bff", color: "#fff" }}>
        <Modal.Title>Create Proforma Invoice</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {/* Pass handleCreate to InvoicePage */}
        <InvoicePage handleCreate={handleCreate} />
      </Modal.Body>

      <Modal.Footer>
        <Button onClick={handleClose} variant="secondary">
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default InvoiceModalPage;
